import { Link } from "react-router-dom";

export const Logo = ({ dark = false, testid = "brand-logo" }) => (
  <Link to="/" data-testid={testid} className="flex items-center gap-2.5 shrink-0" aria-label="Cloud Center Costa Rica - Inicio">
    <span className={`grid place-items-center rounded-lg ${dark ? "bg-white p-1" : ""}`}>
      <img src="/logo-mark.png" alt="" width="34" height="34" className="h-8 w-8 object-contain" />
    </span>
    <span className="leading-none">
      <span className={`block font-display text-lg font-semibold tracking-tight ${dark ? "text-white" : "text-[color:var(--cc-charcoal)]"}`}>Cloud Center</span>
      <span className={`block font-mono text-[10px] uppercase tracking-[0.3em] ${dark ? "text-slate-400" : "text-slate-500"}`}>Costa Rica</span>
    </span>
  </Link>
);
